module.exports = __webpack_public_path__ + "img/V13.45b1376a.jpg";